import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "as-player-team" }
const _hoisted_2 = {
  key: 0,
  class: "as-player-team-item"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "as-player-team-name" }
const _hoisted_5 = {
  key: 1,
  class: "as-player-team-item"
}
const _hoisted_6 = { class: "as-player-team-name" }
const _hoisted_7 = ["src"]


import type {
  ILineups,
  IMatch,
  IPlayer,
  IIncidentStatistic,
} from "~src/interfaces";
import { formatRateColor } from "~src/helpers";


const __default__ = {};

interface IProps {
  match: IMatch;
  lineups: ILineups;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PlayerTeamTab',
  props: {
    match: {},
    lineups: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.match && _ctx.match.home_team)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: 
          _ctx.getImgUrlBySport('team', _ctx.match.home_team.id)
        
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.match.home_team.name), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.match && _ctx.match.away_team)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.match.away_team.name), 1),
          _createElementVNode("img", {
            src: _ctx.getImgUrlBySport('team', _ctx.match.away_team.id)
          }, null, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})